<script>

    import { toast } from 'bulma-toast'
    import { modalStore, pickupsStore } from '../stores'

    import PickupsService from '../$services/pickups.svelte'
    import DateMethod from '../$methods/date.method'
    import TranslateMethods from '../$methods/translate.methods.js'

    import Pagination from '../$components/pagination.svelte'
    import Search from '../$components/input.search.svelte'
    import Select from '../$components/select.svelte'
    import Table from '../$components/table.svelte'
    import Button from '../$components/button.svelte'

    let query = {
        page: 0,
        find: null,
        admin: true
    }
    let metadata = {}
    let loading = false

    getPickups()

    async function getPickups() {

        loading = true
        const resp = await PickupsService.getPickups(query)
        loading = false

        if(!resp.success)
            return toast({message: resp.error.message, type: 'is-danger'})

        pickupsStore.set(resp.data.pickups)
        metadata = resp.data.metadata
    }

</script>

<Table items={$pickupsStore.length} total={metadata.total} {loading}>
    <div slot="toolbar">
        <div class="columns is-multiline is-align-items-flex-end mb-0">
            <div class="column">
                <Search bind:value={ query.find } on:enter={ getPickups } />
            </div>
            <div class="column is-narrow">
                <Select bind:value={ query.status } on:change={ getPickups }
                    text="Estatus"
                    options={[
                        {value: 'pending', text: 'Pendiente'},
                        {value: 'success', text: 'Agendada'},
                        {value: 'canceled', text: 'Cancelada'},
                    ]}
                />
            </div>
        </div>
    </div>
    <div slot="footer">
        <Pagination bind:metadata bind:page={ query.page } on:change={ getPickups } />
    </div>
    <thead>
        <tr>
            <th>#</th>
            <th>Estatus</th>
            <th>Usuario</th>
            <th>Proveedor</th>
            <th>Guía</th>
            <th>Fecha</th>
            <th class="has-text-right">Acciones</th>
        </tr>
    </thead>
    <tbody>
        {#each $pickupsStore as pickup, index}
            <tr>
                <td>{(metadata.items * query.page) + (index + 1)}</td>
                <td>{TranslateMethods.get(pickup.status)}</td>
                <td>
                    <div>
                        <span>{pickup.user.name}</span>
                        <span>{pickup.user.email}</span>
                    </div>
                </td>
                <td>{pickup.provider}</td>
                <td>{pickup.guide}</td>
                <td>{DateMethod.dateLarge(pickup.date)}</td>
                <td>
                    <Button on:click={() => modalStore.open('pickup', 'modal', pickup)} icon="ellipsis-v" />
                </td>
            </tr>
        {/each}
    </tbody>
</Table>
